import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'localOffers:useMyCurrentLocation:buttonTitle': {
    id: 'localOffers:useMyCurrentLocation:buttonTitle',
    defaultMessage: 'Use My Current Location',
    description: 'Title for the Use My Current Location button on Local Offers Location Selector page',
  },
  'localOffers:useMyCurrentLocation:buttonSubtitle': {
    id: 'localOffers:useMyCurrentLocation:buttonSubtitle',
    defaultMessage: '{marketingTitle} will use your location',
    description: 'Subtitle for the Use My Current Location button on Local Offers Location Selector page',
  },
  'localOffers:searchField:placeholderText': {
    id: 'localOffers:searchField:placeholderText',
    defaultMessage: 'Search by street or ZIP code',
    description: 'Placeholder text for the Local Offers Location Selector page header',
  },
});
